import getDesignDataForExport from 'editor/src/store/design/selector/getDesignDataForExport';
import getPersonalizationIsValid from 'product-personalizer/src/store/productPersonalizer/selector/getPersonalizationIsValid';

import store from 'product-personalizer/src/store';

import { getEcomProxyEndpoint, getStoreConfig } from './config';

const saveDesign = (customerReferenceId: string | undefined): Promise<unknown> => {
  const state = store.getState();
  const { images } = state.gallery;
  const addons = state.editorModules.addons.inUse;
  const { designData } = state.design;

  if (!designData) {
    return Promise.resolve(undefined);
  }

  if (!getPersonalizationIsValid(state)) {
    // eslint-disable-next-line no-console
    console.warn('[product-personalizer] saveDesign blocked: a locked text box has reached its character cap.');
    return Promise.resolve(undefined);
  }

  const designDataForExport = JSON.stringify(getDesignDataForExport(designData, images, addons, []));

  const { storeId, clientId } = getStoreConfig();

  return fetch(`${getEcomProxyEndpoint()}/designs`, {
    method: 'POST',
    body: JSON.stringify({
      structure: designDataForExport,
      accessMode: 'public',
      customerReferenceId,
      ...(storeId && { storeId }),
      ...(clientId && { clientId }),
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => data)
    .catch(() => {});
};

export default saveDesign;
